const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  name: (lambdaParameter, value) =>
    `${lambdaParameter}.Name.Contains("${value}")`,
  parentId: (lambdaParameter, value) => `${lambdaParameter}.ParentId==${value}`,
  parentIds: (lambdaParameter, value) =>
    `new int%3F[] {${(
      value as number[]
    )?.toString()}}.Contains(${lambdaParameter}.ParentId)`,
  backgroundImageId: (lambdaParameter, value) =>
    `${lambdaParameter}.BackgroundImageId.Equals(${value})`,
  itemsIds: (lambdaParameter, value) =>
    `${lambdaParameter}.ItemsIds.Contains(${value})`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.Name).Contains("${q}")`,
      )
      .join('&&')}`,
  excludeId: (lambdaParameter, value) => `${lambdaParameter}.Id != ${value}`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
